import axios from 'axios';
import generateBackendUrl from '../constants/api.routes.constants';
import generateToken from '../services/jwt.service';

const forceLogout = () => {
  localStorage.removeItem('jwt');
};

const axiosInstance = axios.create({
  baseURL: '/serviciospnc-web/rest/',
});

/**
 * Interceptor para las peticiones al backend, en caso de tener
 * informada una credencial en el localStorage esta se adjunta
 * en la cabecera para ser enviada en cada petición.
 */
axiosInstance.interceptors.request.use(
  async (config) => {
    const conf = config;
    const jwt = localStorage.getItem('jwt');

    if (jwt) {
      conf.headers = {
        ...conf.headers,
        Authorization: `Bearer ${jwt}`,
      };
    }
    return conf;
  },
  (error) => Promise.reject(error)
);

/**
 * Interceptor para las respuestas del backend, en caso que la
 * petición devuelva un código de error HTTP 401 porque carece
 * de credenciales válidas de autenticación se va a buscar una
 * nueva credencial y se lanza una nueva petición con la
 * credencial actualizada.
 *
 * En caso de error a la hora de ir a buscar una nueva credencial
 * está limpia el localStorage y redirige a una página de error.
 */
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error?.config;

    if (error?.response?.status === 401) {
      const data = await generateToken(generateBackendUrl().GET_TOKEN);
      if (data?.status === 200) {
        localStorage.setItem('jwt', data?.data);
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${data?.data}`,
        };
        return axios(config);
      }

      forceLogout();
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
